import { createContext, useContext } from "react";
import type { DownloadManager } from "../index";

export const DownloadsContext = createContext<DownloadManager | null>(null);

export const useDownloads = () => {
  const downloads = useContext(DownloadsContext);
  if (!downloads) throw new Error("useDownloads requires RuntimeProvider");
  return downloads;
};
